import http from "@/util/http";

export default {
    getOriginalURL(url) {
        return new Promise((resolve, reject) => {
            http.fetchShortUrlApiWithEncrypt`GetOriginalURL${{
                ShortUrl: url
            }}
            ${json => {
                if (json.status) {
                    resolve(json.data);
                } else {
                    reject(json.message);
                }
            }}`;
        })
    },
}